import React, {Component} from 'react';
import InputText from 'components/atoms/inputs/input-text';
import NumberHelper from 'helpers/number-helper';
import Const from 'constants';

class LineupsQuantity extends Component {
    onBlur(rawValue) {
        const value = NumberHelper.prepareInt(rawValue, 1)
            .limitByRange(1, Const.MAX_GENERATED_LINEUPS_QUANTITY, 1)
            .get();
        this.props.onBlur(value);
    }

    render() {
        return <InputText className="input-sm" value={this.props.value} onBlur={::this.onBlur} />;
    }
}

export default LineupsQuantity;
